import Job from '../../../../../models/job.js';
import { CompaniesRegistrar } from '../../../../../models/company.js';
import { isRegistrar } from '../../../../../helpers/registrars.js';

export interface HMRCJobError {
  message: string;
  hmrcCode: string | null;
  retryable: boolean;
  reauthRequired: boolean;
  declined: boolean;
}
export interface TargetBusiness {
  name: string;
  vatNumber: string;
  address: {
    line1: string;
    postcode: string;
    countryCode: string;
  };
}

// The 'VERIFIED_BUSINESS' job metadata entry is written once HMRC confirms the business; its
// value is a JSON-encoded { target: TargetBusiness } envelope.
export function extractVerifiedBusiness(metadata: Job['metadata']): TargetBusiness | undefined {
  const entry = metadata.find((m) => m.key === 'VERIFIED_BUSINESS');
  if (!entry || !entry.value) return undefined;

  return JSON.parse(entry.value).target;
}

// A business matches when the company's Companies House entry agrees with HMRC's name and address. Only that entry is compared:
// the HMRC entry is HMRC's own, and the bank entry holds the bank's name, not the company's.
export function businessMatchesRegistrar(targetBusiness: TargetBusiness, registrar: CompaniesRegistrar[]): boolean {
  return registrar.every((entry) => {
    if (!isRegistrar(entry, 'COMPANIES_HOUSE')) return true;

    return (
      targetBusiness.name === entry.companyName &&
      targetBusiness.address.line1 === entry.registeredAddress.address1 &&
      targetBusiness.address.postcode === entry.registeredAddress.postcode
    );
  });
}
